<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">{{ `${index + 1}、` }}</span>
          </div>
          <div class="question-select">
            <span>完型填空</span>
          </div>
          <div class="question-text">
            <div class="add-batch" @click="handleAnswerAndScore">
              答案与分值
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <!-- <textarea
          ref="introTextarea"
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请选择一个选项"
          maxlength="500"
          auto-height
          @input="handleCaseProblemInput"
          @focus="textareaFocus"
          @blur="textareaBlur"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->
        <MyEditor
          v-model="caseProblem"
          placeholder="请选择一个选项"
          @input="handleUpdate"
          @insertImg="handleCaseProblemImg"
          ref="myEditor"
        />
      </div>
      <div class="question-images">
        <div
          v-for="(item, idx) in images"
          :key="idx"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(idx)"
          />
        </div>
      </div>
      <div class="options" v-for="(item, idx) in list" :key="idx">
        <div v-for="(option, optIdx) in item.title" :key="optIdx">
          <div class="option-item">
            <div class="option-item-top">
              <div class="option-item-top-left">
                <img
                  v-if="item.title.length > 2"
                  @click="delItem(idx, optIdx)"
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                />
                <img
                  v-else
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
                />
              </div>
              <div
                class="option-item-top-right"
                :style="{
                  border:
                    inputFocusIndex === `a${optIdx}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <div class="option-item-top-right-up">
                  <el-input
                    type="text"
                    :placeholder="'选项' + (optIdx + 1)"
                    v-model="option.text"
                    @focus="inputFocusIndex = 'a' + optIdx"
                    @blur="inputFocusIndex = ''"
                    @input="handleUpdate"
                  ></el-input>
                  <div class="option-item-top-right-right">
                    <div class="true-answer">
                      {{ option.isCorrect ? "正确答案" : "" }}
                    </div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
                      style="width: 18px; height: 18px; cursor: pointer"
                      @click="handleItemImage(idx, optIdx)"
                    />
                  </div>
                </div>

                <div class="question-images">
                  <div
                    class="question-images-box"
                    v-for="(imgItem, imgIndex) in option.img_path"
                    :key="imgIndex"
                    style="
                      margin-top: 10px;
                      position: relative;
                      margin-bottom: 5px;
                    "
                  >
                    <img :src="imgItem" class="thumbnail-image" />
                    <div class="fangda-box">查看图片</div>
                    <img
                      src="@/assets/images/guanbi.png"
                      class="guanbi"
                      @click="handleDeleteItemImage(idx, optIdx, imgIndex)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="addChild(idx)" class="add-child">
          <div class="plus-icon"></div>
          <span>添加选项</span>
        </div>
      </div>
      <div class="add-view">
        <div class="required custom-check-box">
          <el-checkbox v-model="isMust" label="必选题"></el-checkbox>
        </div>
        <div @click="addFillSymbol" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 13px; height: 13px"
          />
          <span>插入填空符</span>
        </div>
        <div></div>
      </div>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <!-- <uploadImage
      :show="showUpload"
      :maxCount="1"
      :images="0"
      @upload-close="showUpload = false"
      @upload-success="handleUploadComplete"
    ></uploadImage> -->
    <ExamAnswerSetting
      :show="showSetting"
      @close="showSetting = false"
      :dataObj="settingObj"
      @confirm="handleSettingChange"
    ></ExamAnswerSetting>
    <!-- <PopupPrompt
      :show="showPrompt"
      @close="showPrompt = false"
      :title="promptTitle"
      :content="promptContent"
      :cancel="promptCancel"
      :confirm="promptConfirm"
      @cancel="showPrompt = false"
      @confirm="handlePromptConfirm"
    ></PopupPrompt> -->
    <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
      <div class="popup-content" @click.stop>
        <img
          src="@/assets/images/guanbi.png"
          class="popup-guanbi"
          @click="fangdaClose"
        />
        <div class="popup-scroll">
          <div>{{ fangdaTitle }}</div>
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import ExamAnswerSetting from "@/components/ExamAnswerSetting/ExamAnswerSetting.vue";
export default {
  name: "ExamEditClozeTest",
  components: {
    PopupInput,
    // uploadImage: () => import("@/components/uploadImage"),
    ExamAnswerSetting,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
  },
  data() {
    return {
      ifRandomize: false,
      isMust: false,
      images: [],
      showUpload: false,
      caseProblem: "",
      cursor: 0,
      isFocusIndex: "",
      inputFocusIndex: "",
      showSetting: false,
      settingObj: {},
      oldFillSymbol: 0,
      showPrompt: false,
      promptType: "",
      promptTitle: "",
      promptContent: "",
      promptConfirm: "确定",
      promptCancel: "取消",
      questionScore: 0,
      chooseAnswer: "",
      explanation: "",
      scoringMethod: 0,
      list: [],
      uploadIndex: -1,
      uploadSubIndex: 0,
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      dataObj: {},
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue) {
          this.dataObj = newValue;
          this.oldFillSymbol =
            (newValue.caseProblem || "").split("____").length - 1;
          this.caseProblem = newValue.caseProblem || "";
          this.ifRandomize = newValue.ifRandomize === 1;
          this.isMust = newValue.isMust === 1;
          this.images = newValue.caseProblemImg
            ? JSON.parse(newValue.caseProblemImg)
            : [];
          this.questionScore = newValue.questionScore || 0;
          this.explanation = newValue.analysis || "";
          this.scoringMethod = newValue.scoringMethod || 0;
          this.list = newValue.chooseList
            ? JSON.parse(newValue.chooseList).list
            : [];

          console.log("43r7tr87dh7e1et12et12e812uuuuuuu", this.dataObj);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleCaseProblemInput() {
      const fillSymbolCount = this.caseProblem.split("____").length - 1;
      let newList1 = this.list;
      let newList2 = [];
      for (let i = 0; i < fillSymbolCount; i++) {
        newList2.push(newList1[i]);
      }
      this.list = newList2;
      this.handleUpdate();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    textareaBlur(e) {
      this.cursor = e.target.selectionStart || 0;
    },
    textareaFocus() {
      this.isFocusIndex = "-1";
      const textarea = this.$refs.introTextarea;
      this.cursor = textarea.selectionStart;
    },
    textareaBlur(e) {
      this.isFocusIndex = "";
      const textarea = this.$refs.introTextarea;
      this.cursor = textarea.selectionStart;
      console.log("this.cursor", this.cursor);
    },
    addFillSymbol() {
      setTimeout(() => {
        // const newText =
        //   this.caseProblem.slice(0, this.cursor) +
        //   "____" +
        //   this.caseProblem.slice(this.cursor);
        // this.caseProblem = newText;
        // const fillSymbolCount = this.caseProblem.split("____").length - 1;

        this.$refs.myEditor.insertPlaceholder();

        this.list.push({
          id: "",
          title: [
            {
              id: "",
              text: "",
              isChoose: false,
              img_path: [],
              is_fill: 0,
              fill_prompt: "",
            },
            {
              id: "",
              text: "",
              isChoose: false,
              img_path: [],
              is_fill: 0,
              fill_prompt: "",
            },
            {
              id: "",
              text: "",
              isChoose: false,
              img_path: [],
              is_fill: 0,
              fill_prompt: "",
            },
          ],
        });

        const updatedDataObj = {
          ...this.dataObj,
          isMust: this.isMust ? 1 : 0,
          ifRandomize: this.ifRandomize ? 1 : 0,
          caseProblemImg: JSON.stringify(this.images),
          caseProblem:
            this.caseProblem === "" ? "请填写本项内容" : this.caseProblem,
          questionScore: this.questionScore,
          analysis: this.explanation,
          scoringMethod: this.scoringMethod,
          chooseList: JSON.stringify({ list: this.list }),
        };

        this.$emit(
          "update",
          JSON.stringify({
            index: this.index,
            data: updatedDataObj,
          }),
        );
      }, 100);
    },
    addChild(idx) {
      this.list[idx].title.push({
        id: "",
        text: "",
        isChoose: false,
        img_path: [],
        is_fill: 0,
        fill_prompt: "",
        score: 0,
      });
    },
    delItem(idx, optIdx) {
      if (this.updateType === 1) {
        if (this.list[idx].title[optIdx].newDate) {
          this.list[idx].title.splice(optIdx, 1);
        } else {
          this.$message.error("限制性修改状态下，不能删除之前的数据!");
        }
      } else {
        this.list[idx].title.splice(optIdx, 1);
      }
      this.handleUpdate();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleItemImage(index) {
      this.uploadIndex = index;
      this.uploadSubIndex = subIndex;
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].title[this.uploadSubIndex].img_path = [
              response.data.urls,
            ];
          }
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleUploadComplete(images) {
      if (this.uploadIndex === -1) {
        this.images = images;
      } else {
        this.list[this.uploadIndex].title[this.uploadSubIndex].img_path =
          images;
      }
      this.showUpload = false;
      this.handleUpdate();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    handleDeleteItemImage(idx, optIdx, imgIndex) {
      this.list[idx].title[optIdx].img_path.splice(imgIndex, 1);
      this.handleUpdate();
    },
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text;
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
    handleAnswerAndScore() {
      console.log("43r7tr87dh7e1et12et12e812", this.dataObj);

      this.settingObj = {
        ...this.dataObj,
        caseProblem: this.caseProblem,
        questionScore: this.questionScore,
        explanation: this.explanation,
        scoringMethod: this.scoringMethod,
        chooseList: JSON.stringify({ list: this.list }),
      };
      this.showSetting = true;
    },
    handleSettingChange(e) {
      const parsed = JSON.parse(e);
      this.questionScore = parsed.questionScore;
      this.explanation = parsed.explanation;
      this.scoringMethod = parsed.scoringMethod;
      this.list = JSON.parse(parsed.chooseList).list;

      const fillSymbolCount = this.caseProblem.split("____").length - 1;
      const updatedDataObj = {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        ifRandomize: this.ifRandomize ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem:
          this.caseProblem === "" ? "请填写本项内容" : this.caseProblem,
        questionScore: this.questionScore,
        analysis: this.explanation,
        scoringMethod: this.scoringMethod,
        chooseList: JSON.stringify({
          list: JSON.parse(parsed.chooseList).list,
        }),
      };

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: updatedDataObj,
        }),
      );
      this.showSetting = false;
    },
    saveClick() {
      const isCorrect = this.list.every((item) => {
        return item.title.some((titleItem) => titleItem.isCorrect === true);
      });
      if (!isCorrect) {
        this.$message.error("请设置正确答案");
        return;
      }
      this.saveData();
    },
    handlePromptConfirm() {
      this.showPrompt = false;
      this.saveData();
    },
    saveData() {
      if (this.caseProblem.trim() === "" && this.caseProblem.includes(" ")) {
        this.$message.error("请输入题目");
        return;
      }
      if (!this.caseProblem.trim().includes("____")) {
        this.$message.error("请插入填空符");
        return;
      }
      if (this.list.length < this.caseProblem.split("____").length - 1) {
        this.$message.error("请输入答案");
        return;
      }

      const isCorrect = this.list.every((item) => {
        return item.title.some((titleItem) => titleItem.isChoose === true);
      });
      if (isCorrect) {
        this.$message.error("请输入答案");
        return;
      }

      const fillSymbolCount = this.caseProblem.split("____").length - 1;
      const updatedDataObj = {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        ifRandomize: this.ifRandomize ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem:
          this.caseProblem === "" ? "请填写本项内容" : this.caseProblem,
        questionScore: this.questionScore,
        analysis: this.explanation,
        scoringMethod: this.scoringMethod,
        chooseList: JSON.stringify({
          list: this.list.map((temp, idx) => {
            const newTitle = temp.title.map((titleItem, titleIdx) => {
              return {
                ...titleItem,
                text:
                  titleItem.text === ""
                    ? `选项${titleIdx + 1}`
                    : titleItem.text,
              };
            });
            return {
              ...temp,
              title: newTitle,
            };
          }),
        }),
      };

      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: updatedDataObj,
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleUpdate() {
      const fillSymbolCount = this.caseProblem.split("____").length - 1;
      const updatedDataObj = {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        ifRandomize: this.ifRandomize ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem: this.caseProblem,
        questionScore: this.questionScore,
        chooseAnswer: this.chooseAnswer,
        analysis: this.explanation,
        scoringMethod: this.scoringMethod,
        chooseList: JSON.stringify({ list: this.list }),
      };

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: updatedDataObj,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.clear-btn {
  width: 31px;
  height: 18px;
  background: #ffffff;
  border: 1px solid #3a60ff;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px;
  margin-left: 6px;
  cursor: pointer;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 13px;
}

.add-btn {
  // width: 306px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #00c755;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #00c755;
    margin-left: 11px;
  }
}

.del1 {
  width: 19px;
  height: 19px;
  cursor: pointer;
}

.options {
  padding: 10px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 1px;
  margin-top: 10px;
}

.add-child {
  width: 106px;
  height: 32px;
  background: #ffffff;
  border: 0.5px solid #3a60ff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto 0;
  cursor: pointer;

  span {
    font-size: 12px;
    font-weight: 400;
    color: #3a60ff;
    margin-left: 10px;
  }
}

.plus-icon {
  position: relative;
  width: 12px;
  height: 12px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-color: #3a60ff;
  }

  &::before {
    left: 50%;
    top: 0;
    width: 1px;
    height: 100%;
    transform: translateX(-50%);
  }

  &::after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    transform: translateY(-50%);
  }
}

.option-item-top {
  display: flex;
  margin-bottom: 5px;
}

.option-item-top-left {
  margin-right: 5px;
}

.option-item-top-right {
  flex: 1;
  border: 1px solid #dcdde0;
  border-radius: 2px;
  padding: 5px;
}

.option-item-top-right-up {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.option-item-top-right-right {
  display: flex;
  align-items: center;
  margin-left: 5px;
}

.true-answer {
  color: #00c755;
  font-size: 14px;
  margin-right: 10px;
}

.question-images-box {
  cursor: pointer;

  .thumbnail-image {
    width: 100%;
    object-fit: cover;
  }

  .fangda-box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    text-align: center;
    padding: 5px;
    font-size: 12px;
  }
}

.fangda-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .popup-content {
    background: white;
    border-radius: 4px;
    padding: 10px;
    max-width: 90%;
    max-height: 90%;
    position: relative;

    .popup-guanbi {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 15px;
      height: 15px;
      cursor: pointer;
    }

    .popup-scroll {
      max-height: 80vh;
      overflow-y: auto;

      img {
        width: 100%;
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExamEdit/ExamEditClozeTest.vue